/* global onPayButtonClicked */
import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useCart } from "../contexts/CartContext";
import {
  saveGusetCustomerOrder,
  getBuyNow,
  getBuyNowTotal,
  clearBuyNow,
  getProductsByListOfIds,
} from "../services/nonAuthRequets";
import { toast } from "react-toastify";
import { onePayCheckout } from "../services/OnePayPayment";
import { S3_URL_PRODUCTS } from "../utils/constants";
import onepaylogo from "../assets/images/logo/payments/onepay.png";
import cardpaymentLogo from "../assets/images/logo/payments/visa-mastercard-small.png";
import { kokoPay } from "../services/KokoPay";
const DELIVERY_FEE = 400;
const Checkout = () => {
  document.title = "Checkout | Bigmall";
  const [selectedPayment, setSelectedPayment] = useState("payment3");
  const [isCardPaymentsExpanded, setIsCardPaymentsExpanded] = useState(false);
  const [selectedCardPayment, setSelectedCardPayment] = useState("");
  // We only use clearCartAfterCheckout from the cart context for guest checkout.
  const { clearCartAfterCheckout } = useCart();
  const [items, setItems] = useState([]);
  const [isCartLoaded, setIsCartLoaded] = useState(false);
  const [total, setTotal] = useState(0);
  const [isSubmitting, setIsSubmitting] = useState(false);
  function qualifiesForFreeDelivery(product) {
    // Check if the configuration exists and has a "Free_Delivery" key.
    if (product.configuration && product.configuration.Free_Delivery) {
      const freeDeliveryConfig = product.configuration.Free_Delivery;
      return (
        freeDeliveryConfig.configStatus &&
        freeDeliveryConfig.configStatus.toLowerCase() === "active"
      );
    }
    // If no free delivery configuration exists, assume the product does not qualify.
    return false;
  }

  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    address_1: "",
    city: "",
    state: "",
    postCode: "",
    phone: "",
    email: "",
    customerNote: "",
  });

  // Clear BuyNow data if navigating away
  useEffect(() => {
    return () => {
      if (window.location.pathname !== "/checkout") {
        clearBuyNow();
      }
    };
  }, []);

  useEffect(() => {
    const fetchItems = async () => {
      try {
        const buyNowProduct = getBuyNow();
        if (buyNowProduct) {
          setItems([buyNowProduct]);
          setTotal(getBuyNowTotal());
          setIsCartLoaded(true);
          return;
        }

        // For guest users, use localStorage to retrieve cart items.
        const cartItems = JSON.parse(localStorage.getItem("cart")) || [];

        if (cartItems.length > 0) {
          // console.log("CartItems", cartItems);
          const productIds = cartItems.map((item) => item.id);
          // console.log("ProductIds", productIds);
          const response = await getProductsByListOfIds(productIds);
          // console.log("Response", response);
          const productsFromApi = Array.isArray(response)
            ? response
            : response.products;
          // console.log("ProductsFromApi", productsFromApi);
          if (!productsFromApi || productsFromApi.length === 0) {
            return [];
          }
          const productData = cartItems.map((item) => {
            const prodId = item.id;
            // console.log("ProdId", prodId);
            const productWrapper = productsFromApi.find(
              (p) => p.product.id === prodId
            );
            //  console.log("Product", productWrapper);
            if (!productWrapper) return null;
            const product = productWrapper.product;
            return {
              id: product.id,
              name: product.name,
              images: product.images,
              salePrice: product.salePrice,
              regularPrice: product.regularPrice,
              stockQuantity: product.stockQuantity,
              quantity: item.quantity,
              sku: product.sku,
              configuration: product.configuration || null,
            };
          });
          // const itemsData = await Promise.all(
          //   cartItems.map(async (item) => {
          //     const response = await getProductById(item.id);
          //     if (!response || !response.product) return null;
          //     return {
          //       id: response.product.id,
          //       name: response.product.name,
          //       images: response.product.images,
          //       salePrice: response.product.salePrice,
          //       regularPrice: response.product.regularPrice,
          //       stockQuantity: response.stockQuantity,
          //       quantity: item.quantity,
          //       configuration: response.product.configuration
          //         ? response.product.configuration
          //         : null,
          //     };
          //   })
          // );

          //const filteredProducts = itemsData.filter((p) => p !== null);
          const filteredProducts = productData.filter((p) => p !== null);
          setItems(filteredProducts);
          setTotal(
            filteredProducts.reduce((sum, item) => {
              const config = item.configuration;
              const configDiscount =
                config?.Sale?.collectionConfiguration?.discount || 0;
              const discountActive =
                config &&
                configDiscount &&
                config?.Sale?.configStatus === "active";

              let effectivePrice;
              if (discountActive) {
                if (item.salePrice) {
                  // Case 1: Active config with salePrice available; apply discount on salePrice.
                  effectivePrice = item.salePrice * (1 - configDiscount / 100);
                } else {
                  // Case 3: Active config but no salePrice; calculate effective price from regularPrice.
                  effectivePrice =
                    item.regularPrice * (1 - configDiscount / 100);
                }
              } else {
                // Cases 2 & 4: No active config; use salePrice if available, otherwise regularPrice.
                effectivePrice = item.salePrice || item.regularPrice;
              }
              return sum + item.quantity * effectivePrice;
            }, 0)
          );

          //setIsCartLoaded(true);
        }

        setIsCartLoaded(true);

        // If no items are found, redirect to home.
        if (cartItems.length === 0) {
          navigate("/");
        }
      } catch (error) {
        console.error("Error loading cart:", error);
        setIsCartLoaded(true);
        navigate("/");
      }
    };

    fetchItems();
  }, [navigate]);

  const allFreeDelivery = items.every(qualifiesForFreeDelivery);
  //console.log("All free delivery:", allFreeDelivery);
  const deliveryFee = allFreeDelivery ? 0 : DELIVERY_FEE;

  useEffect(() => {
    if (selectedPayment === "payment5") {
      const handleOnePaySuccess = (e) => {
        // console.log("OnePay Payment SUCCESS", e.detail);
        const buyNow = getBuyNow();
        if (buyNow) {
          clearBuyNow();
        } else {
          clearCartAfterCheckout();
        }
        navigate("/");
      };

      const handleOnePayFail = (e) => {
        // console.log("Payment FAIL from React:", e.detail);
        navigate("/");
      };

      window.addEventListener("onePaySuccess", handleOnePaySuccess);
      window.addEventListener("onePayFail", handleOnePayFail);

      return () => {
        window.removeEventListener("onePaySuccess", handleOnePaySuccess);
        window.removeEventListener("onePayFail", handleOnePayFail);
      };
    }
  }, [selectedPayment, navigate, clearCartAfterCheckout]);

  // const handlePaymentChange = (event) => {
  //   setSelectedPayment(event.target.id);
  // };
  const handlePaymentChange = (e) => {
    const payment = e.target.value;
    setSelectedPayment(payment);
    // When Card Payments is selected, expand its options.
    if (payment === "cardPayments") {
      setIsCardPaymentsExpanded(true);
    } else {
      setIsCardPaymentsExpanded(false);
    }
  };
  const handleCardPaymentChange = (e) => {
    setSelectedCardPayment(e.target.value);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (isSubmitting) return;
    setIsSubmitting(true);

    const paymentMethodMap = {
      payment3: "COD",
      payment4: "Payhere",
      payment5: "OnePay",
      payment6: "KokoPay",
    };

    const lineItems = items.map((item) => ({
      productId: item.id,
      quantity: item.quantity,
      salePrice: item.salePrice || item.regularPrice,
    }));
    //console.log("Sending lineItems:", JSON.stringify(lineItems));

    const orderDTO = {
      paymentMethod:
        selectedPayment === "cardPayments"
          ? paymentMethodMap[selectedCardPayment]
          : paymentMethodMap[selectedPayment],
      customerId: null, // Guest order
      billing: {
        first_name: formData.firstName,
        last_name: formData.lastName,
        address_1: formData.address_1,
        city: formData.city,
        state: formData.state,
        postCode: formData.postCode,
        country: "Sri Lanka",
        phone: formData.phone,
        email: formData.email,
      },
      lineItems: lineItems,
      shippingLines: null,
      couponLines: null,
      customerNote: formData.customerNote || null,
      totalPrice: total.toFixed(2),
      firstName: formData.firstName,
      lastName: formData.lastName,
      email: formData.email,
      phoneNumber: formData.phone,
      totalPrice: total.toFixed(2),
      deliveryFee: deliveryFee.toFixed(2),
      kokoTax: kokoTax.toFixed(2),
    };

    try {
      const response = await saveGusetCustomerOrder(orderDTO);
      // console.log("Order submitted successfully:", response.object);

      if (
        selectedPayment === "cardPayments" &&
        selectedCardPayment === "payment4"
      ) {
        // PayHere flow
        const { customOrderId, payHereDTO } = response.object;

        const payment = {
          sandbox: process.env.REACT_APP_PAYHERE_SANDBOX,
          merchant_id: payHereDTO.merchantId,
          return_url: payHereDTO.returnUrl,
          cancel_url: payHereDTO.cancelUrl,
          notify_url: payHereDTO.notifyUrl,
          order_id: customOrderId,
          items: payHereDTO.orderNumber,
          amount: payHereDTO.amount,
          currency: payHereDTO.currency,
          hash: payHereDTO.hash,
          first_name: formData.firstName,
          last_name: formData.lastName,
          email: formData.email,
          phone: formData.phone,
          address: formData.address_1,
          city: formData.city,
          country: "Sri Lanka",
          delivery_address: formData.address_1,
          delivery_city: formData.city,
          delivery_country: "Sri Lanka",
          custom_1: "WEB",
          custom_2: "",
        };
        //console.log("PayHere payment object:", payment);
        sessionStorage.setItem("orderId", response.object.customOrderId);
        window.payhere.onCompleted = function (orderId) {
          // console.log("Payment completed. OrderID:" + orderId);
          // const buyNow = getBuyNow();
          // if (buyNow) {
          //   clearBuyNow();
          // } else {
          //   clearCartAfterCheckout();
          // }
        };
        window.payhere.onDismissed = function () {
          // console.log("Payment dismissed");
        };
        window.payhere.onError = function (error) {
          console.error("Payment error:", error);
        };

        window.payhere.startPayment(payment);
      } else if (
        selectedPayment === "cardPayments" &&
        selectedCardPayment === "payment5"
      ) {
        const { customOrderId, onePayDTO } = response.object;
        const onePayData = {
          currency: "LKR",
          app_id: onePayDTO.appId,
          amount: onePayDTO.amount,
          reference: `Bigmall-${onePayDTO.generatedOrderId}`,
          customer_first_name: formData.firstName,
          customer_last_name: formData.lastName,
          customer_phone_number: formData.phone,
          customer_email: formData.email,
          transaction_redirect_url: onePayDTO.transactionRedirectUrl,
          additional_data: customOrderId,
          hash: onePayDTO.hash,
        };
        //console.log("OnePay data object:", onePayData);

        try {
          const responseOnePay = await onePayCheckout(
            onePayData,
            onePayDTO.appToken
          );
          //console.log("OnePay response:", response);
          if (responseOnePay.status === 200) {
            sessionStorage.setItem("orderId", response.object.customOrderId);
            // const buyNow = getBuyNow();
            // if (buyNow) {
            //   clearBuyNow();
            // } else {
            //   clearCartAfterCheckout();
            // }
            // console.log("OnePay payment process initiated successfully.");
            sessionStorage.setItem(
              "onePayTransactionId",
              responseOnePay.data.ipg_transaction_id
            );
            const url = responseOnePay.data.gateway.redirect_url;
            window.location.href = url;
          } else {
            console.error("OnePay request failed:", response);
            toast.error("OnePay payment failed.");
          }
        } catch (error) {
          console.error("OnePay request error:", error);
          toast.error("OnePay payment request failed.");
        }
      } else if (selectedPayment === "payment6") {
        const { kokoDTO } = response.object;

        const kokoPayData = {
          orderId: kokoDTO.orderId,
          amount: kokoDTO.amount,
          description: kokoDTO.description,
          firstName: kokoDTO.firstName,
          lastName: kokoDTO.firstName,
          email: kokoDTO.email,
          reference: kokoDTO.reference,
          phone: kokoDTO.phone,
          returnUrl: kokoDTO.returnUrl,
          cancelUrl: kokoDTO.cancelUrl,
          responseUrl: kokoDTO.responseUrl,
        };
        sessionStorage.setItem("orderId", kokoDTO.orderId);

        kokoPay(kokoPayData);

        //console.log("KOKO Pay data object:", window.kokoPayData);
      } else {
        toast.success("Order submitted successfully!");
        //const buyNow = getBuyNow();
        // if (buyNow) {
        //   clearBuyNow();
        // } else {
        //   clearCartAfterCheckout();
        // }
        sessionStorage.setItem("orderId", response.object.customOrderId);
        const redirectUrl = response.object.orderSuccessUrl;
        window.location.href = redirectUrl;
        //navigate("/");
      }
    } catch (error) {
      console.error("Error submitting order:", error);
      let errorMessage = "Something went wrong!";
      if (error.response && error.response.data) {
        errorMessage = error.response.data.message
          ? error.response.data.message
          : JSON.stringify(error.response.data);
      } else if (error.message) {
        errorMessage = error.message;
      }
      toast.error(`Error submitting order: ${errorMessage}`);
    } finally {
      setIsSubmitting(false);
      if (localStorage.getItem("couponDetails")) {
        localStorage.removeItem("couponDetails");
      }
      //console.log("Order DTO:", orderDTO);
    }
  };

  if (!isCartLoaded) {
    return <div>Loading...</div>;
  }

  const kokoTax =
    selectedPayment === "payment6"
      ? total * 0.07 // 7% of products-only total
      : 0;

  //const grandTotal = total + deliveryFee + kokoTax;

  return (
    <section className="checkout py-20">
      <div className="container container-lg">
        <div className="border border-gray-100 rounded-8 px-5 py-10 mb-10">
          <span>
            Creating an account or login with existing account will give you
            more benefits and save time during checkout.{" "}
            <Link
              to="/login"
              className="fw-semibold text-gray-900 text-sm hover-text-decoration-underline hover-text-main-600"
            >
              Click here to register or login.
            </Link>
          </span>
        </div>
        <form onSubmit={handleSubmit}>
          <div className="row">
            <div className="col-xl-9 col-lg-8">
              <div className="pe-xl-5">
                <div className="row gy-3">
                  <div className="col-sm-6 col-xs-6">
                    <input
                      type="text"
                      className="common-input-two border-gray-100"
                      placeholder="First Name"
                      name="firstName"
                      value={formData.firstName || ""}
                      onChange={handleChange}
                      required
                    />
                  </div>
                  <div className="col-sm-6 col-xs-6">
                    <input
                      type="text"
                      className="common-input-two border-gray-100"
                      placeholder="Last Name"
                      name="lastName"
                      value={formData.lastName || ""}
                      onChange={handleChange}
                      //required
                    />
                  </div>

                  <div className="col-12">
                    <input
                      type="text"
                      className="common-input-two border-gray-100"
                      placeholder="Street Address"
                      name="address_1"
                      value={formData.address_1 || ""}
                      onChange={handleChange}
                      required
                    />
                  </div>
                  {/* <div className="col-sm-6 col-xs-6">
                    <input
                      type="text"
                      className="common-input-two border-gray-100"
                      placeholder="City"
                      name="city"
                      value={formData.city || ""}
                      onChange={handleChange}
                      required
                    />
                  </div> */}
                  <div className="col-sm-6 col-xs-6">
                    <input
                      type="text"
                      className="common-input-two border-gray-100"
                      placeholder="District"
                      name="state"
                      value={formData.state || ""}
                      onChange={handleChange}
                      required
                    />
                  </div>
                  {/* <div className="col-sm-6 col-xs-6">
                    <input
                      type="text"
                      className="common-input-two border-gray-100"
                      placeholder="Post Code"
                      name="postCode"
                      value={formData.postCode || ""}
                      onChange={handleChange}
                    />
                  </div> */}
                  <div className="col-sm-6 col-xs-6">
                    <input
                      type="number"
                      className="common-input-two border-gray-100"
                      placeholder="Phone"
                      name="phone"
                      value={formData.phone || ""}
                      onChange={handleChange}
                      required
                    />
                  </div>
                  <div className="col-sm-6 col-xs-6">
                    <input
                      type="email"
                      className="common-input-two border-gray-100"
                      placeholder="Email Address"
                      name="email"
                      value={formData.email || ""}
                      onChange={handleChange}
                      required
                    />
                  </div>
                  <div className="col-12">
                    <input
                      type="text"
                      className="common-input-two border-gray-100"
                      placeholder="Sri Lanka"
                      disabled
                    />
                  </div>
                  <div className="col-12">
                    <div>
                      <h6 className="text-sm fw-semibold mb-10">
                        Additional Information
                      </h6>
                      <input
                        type="text"
                        className="common-input border-gray-100"
                        placeholder="Notes about your order, e.g. special notes for delivery."
                        name="customerNote"
                        value={formData.customerNote}
                        onChange={handleChange}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-xl-3">
              <div className="checkout-sidebar">
                <div className="bg-color-three rounded-8 p-10 text-center">
                  <span className="text-gray-900 text-sm fw-semibold">
                    Your Order
                  </span>
                </div>
                <div className="border border-gray-100 rounded-8 px-1 py-10 mt-10">
                  <div className="flex-between border-bottom border-gray-100 gap-8 mb-10 pb-10">
                    <span className="text-gray-900 text-sm fw-semibold">
                      Product
                    </span>
                    <span className="text-gray-900 text-sm fw-semibold">
                      Subtotal
                    </span>
                  </div>
                  {items.map((item) => {
                    // Extract configuration from the item
                    const config = item.configuration;
                    const configDiscount =
                      config?.Sale?.collectionConfiguration?.discount || 0;
                    const discountActive =
                      config &&
                      configDiscount &&
                      config.Sale?.configStatus === "active";

                    let effectivePrice;
                    if (discountActive) {
                      if (item.salePrice) {
                        // Case 1: Active config and sale price available; apply discount on salePrice.
                        effectivePrice =
                          item.salePrice * (1 - configDiscount / 100);
                      } else {
                        // Case 3: Active config but no sale price; compute sale price from regularPrice.
                        effectivePrice =
                          item.regularPrice * (1 - configDiscount / 100);
                      }
                    } else {
                      // Cases 2 & 4: No active config; use salePrice if available or fall back to regularPrice.
                      effectivePrice = item.salePrice || item.regularPrice;
                    }

                    return (
                      <div className="flex-between gap-24 mb-10" key={item.id}>
                        <div className="flex-align gap-12">
                          <span className="text-gray-900 text-sm w-100 fw-semibold">
                            {item.name.length > 16
                              ? `${item.name.slice(0, 16)}...`
                              : item.name}
                            <img
                              src={S3_URL_PRODUCTS + item.images[0]}
                              alt={item.name}
                              style={{
                                width: "75px",
                                height: "75px",
                              }}
                            />
                          </span>
                          <span className="text-gray-900 text-sm fw-semibold">
                            <i className="ph-bold ph-x" />
                          </span>
                          <span className="text-gray-900 text-sm fw-semibold">
                            {item.quantity}
                          </span>
                        </div>
                        <span className="text-gray-900 text-sm fw-semibold">
                          LKR {effectivePrice.toFixed(2)}
                        </span>
                      </div>
                    );
                  })}

                  <div className="border-top border-gray-100 pt-10 mt-10">
                    {/* <div className="mb-32 flex-between gap-8">
                      <span className="text-gray-900 font-heading-two text-xl fw-semibold">
                        Subtotal
                      </span>
                      <span className="text-gray-900 font-heading-two text-md fw-bold">
                        LKR{total.toFixed(2)}
                      </span>
                    </div> */}
                    <div className="flex-between gap-8 mb-10">
                      <span className="text-gray-900 text-sm fw-semibold">
                        SubTotal
                      </span>
                      <span className="text-gray-900 text-sm fw-semibold">
                        LKR {total.toFixed(2)}
                      </span>
                    </div>
                    <div className="mb-10 flex-between gap-8">
                      <span className="text-gray-900 text-sm fw-semibold">
                        Delivery Fee
                      </span>
                      <span className="text-gray-900 text-sm fw-semibold">
                        LKR {deliveryFee.toFixed(2)}
                      </span>
                    </div>
                    {kokoTax > 0 && (
                      <div className="mb-10 flex-between gap-8">
                        <span className="text-gray-900 text-sm fw-semibold">
                          Koko Tax
                        </span>
                        <span className="text-gray-900 text-sm fw-semibold">
                          LKR {kokoTax.toFixed(2)}
                        </span>
                      </div>
                    )}
                    <div className="flex-between gap-8">
                      <span className="text-gray-900 text-sm fw-semibold">
                        Total
                      </span>
                      <span className="text-gray-900 text-sm fw-semibold">
                        LKR {(total + deliveryFee + kokoTax).toFixed(2)}
                      </span>
                    </div>
                  </div>
                </div>
                <div className="mt-10">
                  <div className="payment-item">
                    <div className="form-check common-check common-radio mb-0 py-16 d-flex align-items-center">
                      <input
                        className="form-check-input"
                        type="radio"
                        name="payment"
                        id="payment3"
                        value="payment3"
                        checked={selectedPayment === "payment3"}
                        onChange={handlePaymentChange}
                      />
                      <label
                        className="form-check-label text-neutral-600 fw-semibold text-sm"
                        htmlFor="payment3"
                      >
                        Cash on delivery
                      </label>
                    </div>
                    {selectedPayment === "payment3" && (
                      <div className="d-block bg-main-50 position-relative rounded-8 payment-item__content px-16 py-24">
                        <p className="text-gray-800 text-sm">
                          Please use your Order ID as the payment reference.
                        </p>
                      </div>
                    )}
                  </div>
                  <div className="payment-item">
                    <div className="form-check common-check common-radio d-flex align-items-center">
                      <div className="d-flex align-items-center">
                        <input
                          className="form-check-input"
                          type="radio"
                          name="payment"
                          id="cardPayments"
                          value="cardPayments"
                          checked={selectedPayment === "cardPayments"}
                          onChange={() => {
                            if (selectedPayment === "cardPayments") {
                              // Toggle expansion if already selected
                              setIsCardPaymentsExpanded(
                                !isCardPaymentsExpanded
                              );
                            } else {
                              // Select and expand card payments
                              setSelectedPayment("cardPayments");
                              setIsCardPaymentsExpanded(true);
                            }
                          }}
                        />
                        <label
                          className="form-check-label text-neutral-600 fw-semibold text-sm ms-2"
                          htmlFor="cardPayments"
                        >
                          Card Payments
                          <img
                            src={cardpaymentLogo}
                            alt="Card Payments"
                            className="w-25 h-25 ms-5 align-middle"
                          />
                        </label>
                      </div>
                      <div className="ml-auto">
                        {isCardPaymentsExpanded ? (
                          <i className="ph ph-chevron-up" />
                        ) : (
                          <i className="ph ph-chevron-down" />
                        )}
                      </div>
                    </div>
                    {selectedPayment === "cardPayments" &&
                      isCardPaymentsExpanded && (
                        <div className="d-block bg-main-50 position-relative rounded-8 payment-item__content px-10 py-24">
                          <div className="sub-payment-item">
                            <div className="form-check common-check common-radio py-8">
                              <input
                                className="form-check-input"
                                type="radio"
                                name="cardPayment"
                                id="payment4"
                                value="payment4"
                                checked={selectedCardPayment === "payment4"}
                                onChange={handleCardPaymentChange}
                              />
                              <img
                                src="https://www.payhere.lk/downloads/images/payhere_short_banner_dark.png"
                                alt="payhere"
                                className="w-50 h-50 ms-5"
                              />
                            </div>
                            <div className="form-check common-check common-radio  py-8">
                              <input
                                className="form-check-input"
                                type="radio"
                                name="cardPayment"
                                id="payment5"
                                value="payment5"
                                checked={selectedCardPayment === "payment5"}
                                onChange={handleCardPaymentChange}
                              />
                              <img
                                src={onepaylogo}
                                alt="OnePay"
                                className="w-50 h-50"
                              />
                              {/* <label
                                className="form-check-label text-neutral-600 fw-semibold"
                                htmlFor="payment5"
                              >
                                One Pay
                              </label> */}
                            </div>
                          </div>
                        </div>
                      )}
                  </div>

                  {/* KOKOPay */}
                  <div className="payment-item">
                    <div className="form-check common-check common-radio ">
                      <input
                        className="form-check-input"
                        type="radio"
                        name="payment"
                        id="payment6"
                        value="payment6"
                        checked={selectedPayment === "payment6"}
                        onChange={handlePaymentChange}
                      />
                      <img
                        src="https://prod-site-cdn.paykoko.com/bnpl-site-cms-dev/kokoIframeImages/MAINLogo-HD_H_21.01.05.png"
                        className="w-50 h-50"
                        alt="KOKOPay"
                      />
                    </div>
                    {selectedPayment === "payment6" && (
                      <div className="d-block bg-main-50 position-relative rounded-8 payment-item__content px-10 py-24">
                        <p className="text-gray-800 text-sm">
                          <p className="text-gray-800 text-sm">
                            By selecting KOKOPay, a 7% tax will be added to your total. Please review the updated total before proceeding.
                          </p>
                        </p>
                      </div>
                    )}
                  </div>
                </div>
                <div className="mt-32 pt-32 border-top border-gray-100">
                  <p className="text-gray-500 text-sm">
                    Your personal data will be used to process your order,
                    support your experience throughout this website, and for
                    other purposes described in our{" "}
                    <Link
                      to="/privacy-policy"
                      className="text-main-600 text-decoration-underline"
                    >
                      privacy policy
                    </Link>
                    .
                  </p>
                </div>
                <button
                  type="submit"
                  className="btn btn-main w-100 rounded-8 mt-10 btn-sm "
                  disabled={isSubmitting}
                >
                  {isSubmitting ? "Placing Order..." : "Place Order"}
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </section>
  );
};

export default Checkout;
